import styled, { css } from 'styled-components';

interface InputTitleWrapProps {
  title: string;
  children: React.ReactNode;
}

const InputTitleWrap = ({ title, children }: InputTitleWrapProps) => {
  return (
    <>
      <Wrap>
        <h3>{title}</h3>
        <div>{children}</div>
      </Wrap>
    </>
  );
};

export default InputTitleWrap;

const Wrap = styled.div`
  display: grid;
  grid-template-columns: 90px 210px;
  align-items: center;
  > h3 {
    font-size: 15px;
    font-weight: 500;
    color: #333;
  }
`;
